import {isKuhniVersoMebelDomain} from "./isKuhniVersoMebelDomain";

const PUBLIC_PATH_PREFIXES = [
    "/catalog",
    "/news",
    "/stock",
    "/help",
    "/how-to-order",
    "/contacts",
    "/work",
    "/repair-work",
];

const KUHNI_PUBLIC_EXACT_PATHS = ["/", "/home"];

export const isPublicPath = (pathname) => {
    if (isKuhniVersoMebelDomain() && KUHNI_PUBLIC_EXACT_PATHS.includes(pathname)) {
        return true;
    }
    return PUBLIC_PATH_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    );
};
